import { Helper, InputWrapper as _InputWrapper, Label } from 'components/Form/Input'
import Select from 'components/Form/Select'
import I18n from 'components/I18n'
// eslint-disable-next-line import/no-duplicates
import format from 'date-fns/format'
// eslint-disable-next-line import/no-duplicates
import getDaysInMonth from 'date-fns/get_days_in_month'
// eslint-disable-next-line import/no-duplicates
import getYear from 'date-fns/get_year'
// eslint-disable-next-line import/no-duplicates
import parse from 'date-fns/parse'
import messages from 'lang'
import identity from 'lodash/identity'
import times from 'lodash/times'
import React, { useState } from 'react'
import { injectIntl, IntlShape, WrappedComponentProps } from 'react-intl'
import styled from 'styled-components'

const InputWrapper = styled(_InputWrapper)`
  margin-top: 2.25rem;
`

const getYears = () => {
  const offset = getYear(new Date()) - 17
  return times<number>(100, identity).map((n) => offset - n)
}

const getMonths = () => times<number>(12, identity).map((_values, index) => index + 1)

const getDays = (_year, _month) => {
  const year = _year ?? new Date().getFullYear()
  const month = _month ?? 1
  const firstOfMoth = parse(`${year}-${month}-01`)
  const daysInMonth = getDaysInMonth(firstOfMoth)
  return times<number>(daysInMonth, identity).map((_values, index) => index + 1)
}

const getMonthCopy = (intl: IntlShape, month: number) =>
  intl.formatMessage(messages[`month_${month}`])

const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;

  ${/* sc-selector */ Select}:first-child, ${/* sc-selector */ Select}:nth-child(3) {
    flex: 1;
  }
  ${/* sc-selector */ Select}:nth-child(2) {
    flex: 2;
  }
`

type Props = {
  onChange: (string) => void
  value?: string
} & WrappedComponentProps
const DateOfBirth = ({ intl, onChange, value }: Props) => {
  const passedDate = new Date(value ?? '')
  const [day, setDay] = useState<number | undefined>(value ? passedDate.getUTCDate() : undefined)
  const [month, setMonth] = useState<number | undefined>(
    value ? passedDate.getUTCMonth() + 1 : undefined
  )
  const [year, setYear] = useState<number | undefined>(
    value ? passedDate.getUTCFullYear() : undefined
  )

  return (
    <InputWrapper>
      <Label htmlFor='kyc-dob'>
        <I18n data={messages.label_dob} />
      </Label>
      <Row>
        <Select
          name='kyc-dob-year'
          onChange={(e) => {
            const y = e.target.value
            setYear(parseInt(y, 10))
            if (month && year) {
              const newDate = format(`${y}-${month}-${day}`, 'YYYY-MM-DD')
              onChange(newDate)
            }
          }}
          value={year}
        >
          <option value='' />
          {getYears().map((y) => (
            <option key={y} value={y}>
              {y}
            </option>
          ))}
        </Select>
        <Select
          name='kyc-dob-month'
          onChange={(e) => {
            const m = e.target.value
            const nextDay = day && getDays(year, m).length < day ? undefined : day
            setDay(nextDay)
            setMonth(parseInt(m, 10))

            if (nextDay && year) {
              const newDate = format(`${year}-${m}-${nextDay}`, 'YYYY-MM-DD')
              onChange(newDate)
            }
          }}
          value={month}
        >
          <option value='' />
          {getMonths().map((m) => (
            <option key={m} value={m}>
              {getMonthCopy(intl, m)}
            </option>
          ))}
        </Select>
        <Select
          name='kyc-dob-day'
          onChange={(e) => {
            const d = e.target.value
            setDay(parseInt(d, 10))
            if (year && month) {
              const newDate = format(`${year}-${month}-${d}`, 'YYYY-MM-DD')
              onChange(newDate)
            }
          }}
          value={day}
        >
          <option value='' />
          {getDays(year, month).map((day) => (
            <option key={day} value={day}>
              {day}
            </option>
          ))}
        </Select>
      </Row>
      <Helper>
        <I18n data={messages.min_age} />
      </Helper>
    </InputWrapper>
  )
}

export default injectIntl(DateOfBirth)
